import React, { useState } from "react";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";

export default function InputPassword({
  label,
  placeholder,
  col,
  value,
  onChange,
}) {
  const htmlFor = label.replaceAll(" ", "-") || label.replace(/ /g, "-");
  const [type, setType] = useState("password");
  const toggleType = (type) => {
    type === "password" ? setType("text") : setType("password");
  };
  return (
    <>
      <div className={col}>
        <div className="form-group">
          <label className="form-label" htmlFor={htmlFor}>
            {label}
          </label>
          <div className="form-control-wrap">
            <input
              type={type}
              className="form-control"
              id={htmlFor}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              style={{ paddingRight: "25px" }}
            />
            <span
              className="eye-input-password"
              onClick={() => toggleType(type)}
            >
              {type === "password" ? <IoMdEye /> : <IoMdEyeOff />}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
